module.exports = __webpack_public_path__ + "img/unlock-anti-revoke-message.de541283.webp";